const _ = require("lodash");

class Collection {
  constructor({ entries, db, name }) {
    this._entries = entries;
    this.table = entries.reduce((accumulator, entry) => {
      if (!entry.metadata || !entry.metadata.uid) {
        return accumulator;
      }
      accumulator[entry.metadata.uid] = entry;
      return accumulator;
    }, {});
    this.db = db;
    this.name = name;
  }

  find(condition) {
    return _.find(this._entries, condition);
  }

  filter(condition) {
    return _.filter(this._entries, condition);
  }

  get(id) {
    return this.table[id];
  }

  getAll() {
    return this._entries;
  }
}

class DB {
  constructor(collections = {}) {
    this.collections = Object.keys(collections).reduce(
      (accumulator, collectionName) => {
        accumulator[collectionName] = new Collection({
          name: collectionName,
          entries: collections[collectionName],
          db: this,
        });

        return accumulator;
      },
      {},
    );
  }

  collection(name) {
    return this.collections[name];
  }
}

module.exports = DB;
